import { FormProperty } from './formProperty';
import { PropertyTypes } from '../enum/propertyTypes';
import { EventEmitter } from '@angular/core';
import { GSSelectButtonControl } from '../../controls/gsControls';

export class FormSelectButtonProperty extends FormProperty {
  type = PropertyTypes.SelectButton;
  options?: any[];
  changed = new EventEmitter<any>();
  selectedValue: any;
  component = GSSelectButtonControl;

  constructor(
    name: string,
    label: string,
    options?: any[],
    row?: number,
    column?: number,
    rowspan?: number,
    columnspan?: number,
    validate?: boolean,
    styleClass?: string,
    labelClass?: string
  ) {
    super(name, label, row, column, rowspan, columnspan, validate);
    super.styleClass = styleClass;
    super.labelClass = labelClass;
    this.options = options ? options : this.options;
  }
}
